import React from 'react';
import LawyerBottomNav from './LawyerBottomNav';

const LawyerLayout = ({ children }) => {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-purple-50 via-white to-lavender-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="flex-1 pb-16 w-full">
        {children}
      </div>
      <LawyerBottomNav />
    </div>
  );
};

export default LawyerLayout;
